import React from 'react';
import './Footer.scss';

const Footer = () => (
  <footer className="salon-footer" aria-label="Site footer">
    <div className="salon-footer__top">
      <div className="salon-footer__inner">

        {/* Brand column */}
        <div className="salon-footer__col salon-footer__col--brand">
          <div className="salon-footer__logo">
            <span className="salon-footer__logo-script">Priyaa's</span>
            <span className="salon-footer__logo-sub">BEAUTY SALON</span>
          </div>
          <p className="salon-footer__tagline">Where Beauty Meets Luxury</p>
          <address className="salon-footer__address">
            29/9, 1st Main Rd, Jawahar Nagar,<br />
            Perambur, Chennai – 600082,<br />
            Tamil Nadu, India
          </address>
          <div className="salon-footer__contact-links">
            <a href="https://wa.me/919999999999" target="_blank" rel="noreferrer" className="salon-footer__wa">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.557 4.126 1.532 5.862L.054 23.454a.5.5 0 0 0 .638.638l5.798-1.537A11.944 11.944 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.89 0-3.66-.5-5.19-1.369l-.371-.217-3.844 1.018 1.034-3.741-.228-.375A9.972 9.972 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
              </svg>
              WhatsApp Us
            </a>
          </div>
        </div>

        {/* Quick links */}
        <div className="salon-footer__col">
          <h3 className="salon-footer__heading">Quick Links</h3>
          <ul className="salon-footer__list">
            <li><a href="#services">Our Services</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#location">Location</a></li>
            <li><a href="#contact">Book Appointment</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="salon-footer__col">
          <h3 className="salon-footer__heading">Our Services</h3>
          <ul className="salon-footer__list">
            <li>Hair Styling &amp; Cutting</li>
            <li>Bridal &amp; Party Makeup</li>
            <li>Skin &amp; Facial Care</li>
            <li>Hand, Feet &amp; Spa</li>
            <li>Hair Coloring</li>
          </ul>
        </div>

        {/* Hours */}
        <div className="salon-footer__col">
          <h3 className="salon-footer__heading">Opening Hours</h3>
          <div className="salon-footer__hours">
            <div className="salon-footer__hours-row">
              <span>Mon – Sat</span><span>9:00 AM – 8:00 PM</span>
            </div>
            <div className="salon-footer__hours-row">
              <span>Sunday</span><span>10:00 AM – 6:00 PM</span>
            </div>
          </div>
          <a href="#contact" className="salon-footer__book-btn">Book Appointment</a>
        </div>

      </div>
    </div>

    <div className="salon-footer__bottom">
      <p>© {new Date().getFullYear()} Priyaa's Beauty Salon, Perambur, Chennai. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
